import React, {FC, ReactNode} from 'react'
import styles from './styles.css'

export interface FormProps {
  inline?: boolean
  className?: string
  onSubmit?: any
  children: ReactNode
}

export const Form: FC<FormProps> = ({
  inline,
  children,
  className = '',
  ...props
}) => {
  const styleClassName = inline ? styles.inline : styles.normal

  return (
    <form
      noValidate
      className={`${styleClassName} ${className} -visor-no-click`}
      {...props}>
      {children}
    </form>
  )
}
